// extracted by mini-css-extract-plugin
export default {"container":"PageLink_container__Hk0yw","icon":"PageLink_icon__gidPg"};